import { module } from 'modujs';
import { html } from '../utils/environment';
import { gsap } from 'gsap';
import { ScrambleTextPlugin } from "../libs/gsap/ScrambleTextPlugin";

gsap.registerPlugin(ScrambleTextPlugin);


export default class extends module {
    constructor(m) {
        super(m);

		this.events = {
			click: 'toggle'
		}

    }

    init() {

	}

	toggle(e) {	
		e.preventDefault();
			
		this.call('toggle','Contact');
	}

}
